import * as a from "react";
import { p as n } from "./index-efd35e77.js";
import { S as le } from "./index-93802845.js";
import { O as ge, K as Ie } from "./index.es-6889c727.js";
import { f as ce } from "./focus-83744a70.js";
import { d as U } from "./dispatchEvent-96624a5c.js";
import { c as re, v as he, p as ke } from "./package-metadata-a152adb8.js";
import { I as se, t as ye, s as oe } from "./utils-85710523.js";
import { u as Ce } from "./useRtl-f0f2cf5a.js";
import { P as xe } from "./ProgressBar-f33eeff2.js";
import { K as C } from "./keys-029ad48d.js";
import "./index-c07310bf.js";
import "./index-64063129.js";
import "react-dom";
import "./auto-scroll-b2de6e53.js";
var Se = {
  linear: !1,
  mode: "steps",
  value: 0
}, ue = a.createContext(Se), de = 400, me = 0, $, fe = "stepper.optionalText", ie = "stepper.progBarAriaLabel", ve = ($ = {}, $[fe] = "(Optional)", $[ie] = "progressbar", $), W = globalThis && globalThis.__assign || function() {
  return W = Object.assign || function(e) {
    for (var v, c = 1, l = arguments.length; c < l; c++) {
      v = arguments[c];
      for (var s in v)
        Object.prototype.hasOwnProperty.call(v, s) && (e[s] = v[s]);
    }
    return e;
  }, W.apply(this, arguments);
}, Ee = globalThis && globalThis.__rest || function(e, v) {
  var c = {};
  for (var l in e)
    Object.prototype.hasOwnProperty.call(e, l) && v.indexOf(l) < 0 && (c[l] = e[l]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var s = 0, l = Object.getOwnPropertySymbols(e); s < l.length; s++)
      v.indexOf(l[s]) < 0 && Object.prototype.propertyIsEnumerable.call(e, l[s]) && (c[l[s]] = e[l[s]]);
  return c;
}, q = a.forwardRef(function(e, v) {
  var c = e.children, l = e.className, s = e.current, b = e.disabled, T = e.focused, x = e.icon, w = e.svgIcon, d = e.index, u = e.isValid, S = e.label, E = e.optional, _ = e.style, A = e.tabIndex, L = e.text, R = Ee(e, ["children", "className", "current", "disabled", "focused", "icon", "svgIcon", "index", "isValid", "label", "optional", "style", "tabIndex", "text"]), m = a.useContext(ue), F = m.animationDuration, P = m.isVertical, N = m.item, K = m.linear, O = m.mode, p = m.numOfSteps, h = m.value, k = m.onChange, f = m.onFocus, I = m.successIcon, o = m.errorIcon, G = m.successSVGIcon, Q = m.errorSVGIcon, y = a.useRef(null), z = a.useCallback(function() {
    y.current && ce(y.current);
  }, []), M = a.useCallback(function() {
    return {
      element: y.current,
      focus: z
    };
  }, [z]);
  a.useImperativeHandle(v, M);
  var V = !K || d === h - 1 || d === h || d === h + 1, B = O === "labels" || !!x && !!S, X = le(), Y = function(D) {
    return X.toLanguageString(D, ve[D]);
  }, Z = Y(fe), ee = typeof F == "number" ? F : F !== !1 ? de : me, ae = a.useCallback(function(D) {
    k && !b && U(k, D, M(), { value: d });
  }, [k, h, b]), H = a.useCallback(function(D) {
    f && !b && U(f, D, M(), void 0);
  }, [f, b]), r = a.useMemo(function() {
    return re("k-step", {
      "k-step-first": d === 0,
      "k-step-last": p && d === p - 1,
      "k-step-done": d < h,
      "k-step-current": s,
      "k-step-optional": E,
      "k-step-error": u !== void 0 && !u,
      "k-step-success": u
    }, {
      "k-disabled": b,
      "k-focus": T
    }, l);
  }, [d, p, h, s, E, b, T, u, l]), i = a.useMemo(function() {
    return W({ maxWidth: P ? void 0 : "calc(100% / ".concat(p, ")"), maxHeight: P ? "calc(100% / ".concat(p, ")") : void 0, pointerEvents: V ? void 0 : "none" }, _);
  }, [P, p, _, V]), t = u ? I : o, g = t ? a.createElement("span", { className: "k-step-indicator-icon " + t, "aria-hidden": "true" }) : a.createElement(se, { className: "k-step-indicator-icon", name: u ? "check-circle" : "exclamation-circle", icon: u ? G || ge : Q || Ie }), ne = a.createElement(a.Fragment, null, O !== "labels" ? a.createElement("span", { className: "k-step-indicator", "aria-hidden": !0, style: { transitionDuration: ee + "ms" } }, x || w ? !B && u !== void 0 ? g : a.createElement(se, { className: "k-step-indicator-icon", name: x && ye(x), icon: w }) : u !== void 0 ? g : a.createElement("span", { className: "k-step-indicator-text" }, L || d + 1)) : null), te = a.createElement(
    "span",
    { className: "k-step-label" },
    S && a.createElement("span", { className: "k-step-text" }, S),
    B && u !== void 0 && g,
    E && a.createElement("span", { className: "k-step-label-optional" }, Z)
  ), be = a.createElement(
    a.Fragment,
    null,
    ne,
    te
  );
  return a.createElement(
    "li",
    W({ ref: y, className: r, style: i }, R),
    a.createElement("a", { className: "k-step-link", title: S || void 0, onClick: ae, onFocus: H, tabIndex: A || (T ? 0 : -1), "aria-current": s, "aria-disabled": b || !V || void 0, "aria-invalid": u !== void 0 && !u || void 0 }, N ? c : be)
  );
});
q.propTypes = {
  children: n.any,
  className: n.string,
  // content: PropTypes.any,
  current: n.bool,
  disabled: n.bool,
  icon: n.string,
  index: n.number,
  isValid: n.bool,
  label: n.string,
  optional: n.bool,
  style: n.object,
  tabIndex: n.number,
  text: n.string
};
var Ne = {
  tabIndex: 0
};
q.defaultProps = Ne;
q.displayName = "KendoStep";
var j = globalThis && globalThis.__assign || function() {
  return j = Object.assign || function(e) {
    for (var v, c = 1, l = arguments.length; c < l; c++) {
      v = arguments[c];
      for (var s in v)
        Object.prototype.hasOwnProperty.call(v, s) && (e[s] = v[s]);
    }
    return e;
  }, j.apply(this, arguments);
}, J = a.forwardRef(function(e, v) {
  he(ke);
  var c = e.animationDuration, l = e.children, s = e.className, b = e.disabled, T = e.errorIcon, x = e.errorSVGIcon, w = e.item, d = e.items, u = e.linear, S = e.mode, E = e.orientation, _ = e.style, A = e.successIcon, L = e.successSVGIcon, R = e.onChange, m = e.onFocus, F = le(), P = F.toLanguageString(ie, ve[ie]), N = a.useRef(null), K = a.useCallback(function() {
    N.current && ce(N.current);
  }, []), O = a.useCallback(function() {
    return {
      element: N.current,
      focus: K
    };
  }, [K]);
  a.useImperativeHandle(v, O);
  var p = e.value || pe.value, h = a.useState(p), k = h[0], f = h[1], I = d ? d.length : 0, o = E === "vertical", G = Ce(N, e.dir), Q = typeof c == "number" ? c : c !== !1 ? de : me, y = a.useCallback(function(r, i) {
    var t = i === p - 1, g = i === p, ne = i === p + 1, te = !u || t || g || ne;
    p !== i && R && !b && te && (U(R, r, O(), { value: i }), f(i));
  }, [p, u, R, b, f]), z = a.useCallback(function(r) {
    var i = r.value, t = r.syntheticEvent;
    y(t, i);
  }, [y]), M = a.useCallback(function(r) {
    m && !b && U(m, r.syntheticEvent, O(), void 0);
  }, [m, b]), V = a.useCallback(function(r) {
    y(r, k);
  }, [y, k]), B = a.useCallback(function(r) {
    var i = G === "rtl", t = k, g = d.length - 1;
    switch (r.keyCode) {
      case C.left:
        r.preventDefault(), !i && t > 0 && f(t - 1), i && t < g && f(t + 1);
        break;
      case C.right:
        r.preventDefault(), !i && t < g && f(t + 1), i && t > 0 && f(t - 1);
        break;
      case C.up:
        r.preventDefault(), !i && t > 0 && f(t - 1), i && t > 0 && f(t - 1);
        break;
      case C.down:
        r.preventDefault(), !i && t < g && f(t + 1), i && t < g && f(t + 1);
        break;
      case C.home:
        r.preventDefault(), f(0);
        break;
      case C.end:
        r.preventDefault(), f(g);
        break;
      case C.space:
        r.preventDefault();
        break;
      case C.enter:
        r.preventDefault(), d[t].disabled || V(r);
        break;
    }
  }, [d, f, k, G, V]), X = a.useMemo(function() {
    return re("k-stepper", {
      "k-stepper-linear": u
    }, s);
  }, [u, s]), Y = a.useMemo(function() {
    return j({ display: "grid", gridTemplateColumns: o ? void 0 : "repeat(" + I * 2 + ", 1fr)", gridTemplateRows: o ? "repeat(" + I + ", 1fr)" : void 0 }, _);
  }, [o, I, _]), Z = a.useMemo(function() {
    return re("k-step-list", {
      "k-step-list-horizontal": !o,
      "k-step-list-vertical": o
    });
  }, [o]), ee = a.useMemo(function() {
    return {
      gridColumnStart: o ? void 0 : 1,
      gridColumnEnd: o ? void 0 : -1,
      gridRowStart: o ? 1 : void 0,
      gridRowEnd: o ? -1 : void 0
    };
  }, [o]), ae = a.useMemo(function() {
    return {
      gridColumnStart: o ? void 0 : 2,
      gridColumnEnd: o ? void 0 : I * 2,
      gridRowStart: o ? 1 : void 0,
      gridRowEnd: o ? I : void 0,
      top: o ? 17 : void 0
    };
  }, [o, I]), H = d && d.map(function(r, i) {
    var t = j({ index: i, disabled: b || r.disabled, focused: i === k, current: i === p }, r), g = w || q;
    return a.createElement(g, j({ key: i }, t));
  });
  return a.createElement(
    ue.Provider,
    { value: {
      animationDuration: c,
      isVertical: o,
      item: w,
      linear: u,
      mode: S,
      numOfSteps: I,
      value: p,
      successIcon: A,
      successSVGIcon: L,
      errorIcon: T,
      errorSVGIcon: x,
      onChange: z,
      onFocus: M
    } },
    a.createElement(
      "nav",
      { className: X, style: Y, dir: G, onKeyDown: B },
      a.createElement("ol", { className: Z, style: ee }, H || l),
      a.createElement(xe, { style: ae, animation: { duration: Q }, ariaLabel: P, "aria-hidden": !0, max: I - 1, labelVisible: !1, orientation: E, reverse: E === "vertical", value: p, disabled: b, tabIndex: -1 })
    )
  );
});
J.propTypes = {
  animationDuration: n.oneOfType([n.bool, n.number]),
  children: n.any,
  className: n.string,
  dir: n.string,
  disabled: n.bool,
  errorIcon: n.string,
  errorSVGIcon: oe,
  item: n.any,
  items: n.any,
  linear: n.bool,
  mode: n.oneOf(["steps", "labels"]),
  orientation: n.oneOf(["horizontal", "vertical"]),
  style: n.object,
  successIcon: n.string,
  successSVGIcon: oe,
  value: n.number.isRequired,
  onChange: n.func,
  onFocus: n.func
};
var pe = {
  value: 0
};
J.defaultProps = pe;
J.displayName = "KendoStepper";
const Ke = J;
export {
  Ke as Stepper
};
